export const DEFAULT_OVERRIDEABLE_FIELDS = [
  'jsonType',
  'type',
  'name',
  'title',
  'description',
  'options',
  'fieldsets',
  'validation',
  'readOnly',
  'hidden',
  'components',
  'diffComponent',
  'initialValue',
  'deprecated',
]
